import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Index() {
    const navigate = useNavigate();

    useEffect(() => {
        const handlePopState = (event) => {
            event.preventDefault();

            navigate(0);

            console.log("Back navigation prevented");
        };

        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);

    return null;
}

export default Index;
